import withParams from "@src/components/widgets/HOC/withParams";
import React, { useCallback, useMemo } from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetInnovationsUmamiParams } from "../interface";
import LandingInnovationUmami from "design-system/src/Components/WidgetPart/LandingInnovation/LandingInnovationUmami/LandingInnovationUmami";
import useProductList, {
  InnovationProductAdditionalData,
} from "@src/components/widgets/hooks/useProductList";
import { useTranslation } from "@src/hooks/useTranslation";

import useCtaAction from "@src/components/widgets/hooks/useCtaAction";
import InnovationProductUmami from "design-system/src/Components/WidgetPart/LandingInnovation/LandingInnovationUmami/InnovationProductUmami/InnovationProductUmami";
import { IInnovationProductUmamiProps } from "design-system/src/Components/WidgetPart/LandingInnovation/LandingInnovationUmami/InnovationProductUmami/InnovationProductUmami";
import SushishopVideo from "@src/lib/render-video/SushishopVideo/SushishopVideo";

const ProductItemRender = (
  props: IInnovationProductUmamiProps<InnovationProductAdditionalData>
) => {
  const { product: flatProduct, onClick, ...rest } = props;
  const { id_product, actionType, link } = flatProduct;
  const { t } = useTranslation(["landing"]);
  const { generateClick, getSubmitLabel } = useCtaAction(id_product || "");

  return (
    <InnovationProductUmami
      {...rest}
      ctaLabel={getSubmitLabel(false, t("Je commande", "landing"))}
      product={flatProduct}
      onClick={generateClick(
        actionType && actionType === "open_link"
          ? { type: "open_link", link: link || "#" }
          : { type: actionType || "product_card" }
      )}
    />
  );
};

const LandingStandardInnovationsUmami: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetInnovationsUmamiParams>((props) => {
    const { params } = props;
    const { t } = useTranslation(["UI"]);

    const { prepareUmamiProductList } = useProductList(params);

    const productList = useMemo(() => {
      return prepareUmamiProductList(6);
    }, [prepareUmamiProductList]);

    const renderVideo = useCallback(
      (
        videoSlug: string,
        videoRef: React.MutableRefObject<HTMLVideoElement | null>,
        videoProps: React.VideoHTMLAttributes<HTMLVideoElement>
      ) => {
        const { poster, ...rest } = videoProps;
        return (
          <SushishopVideo
            wrapperStyle={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            poster={true}
            customPosterImage={poster}
            ref={(ref) => {
              const innerVideoRef = ref?.getVideoRef();
              if (innerVideoRef) {
                videoRef.current = innerVideoRef;
              }
            }}
            slug={videoSlug}
            controls={false}
            autoPlay={false}
            loop={true}
            muted={true}
            playsInline
            // LCP-FIX: lazyLoad=true → <source> montés seulement au scroll (200px rootMargin),
            // évite N fetchs MP4 concurrents en début de navigation sur listing pages.
            lazyLoad
            preload="none"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        );
      },
      []
    );

    const renderProduct = useCallback(
      (data: IInnovationProductUmamiProps, index: number) => {
        return (
          <ProductItemRender
            key={data.product.id_product + "-" + index}
            {...data}
            renderVideo={renderVideo}
          />
        );
      },
      [renderVideo]
    );
    return (
      <LandingInnovationUmami<InnovationProductAdditionalData>
        products={productList}
        showLessLabel={t("Voir moins", "UI")}
        showMoreLabel={t("Voir plus", "UI")}
        renderProduct={renderProduct}
      />
    );
  });

export default LandingStandardInnovationsUmami;
